/**
 * get usser assets
 * @param {*} state 
 * @param {*} asset 
 */
export function setValidateAssets(state, data) {   
    state.magAssets = data
}

/**
 * get usser assets
 * @param {*} state 
 * @param {*} asset 
 */
export function setVal(state, data) {
    state.assetVal.push(data) 
}

/**
 * Get payment methods
 * 
 */
export function getPayMethods(state, pay) {
    state.paymentMethod = pay
}
export function getAccessFee(state, fee) {
    state.accessFee = fee[0].id
}